export enum AuthProviders {
  LiveSafe = 'livesafe',
  Google = 'google'
}
